import { API_BASE, apiFetch } from "../../api/http";

export type ChecklistResponse = { docType: string; questions: Array<{ question: string; docType: string; sectionId: string }>; sectionLabels: Record<string, string> };

export async function getClientChecklist(docType: "protocol" | "protective"): Promise<ChecklistResponse> {
  const res = await apiFetch(`${API_BASE}/api/clientChecklist/questions?docType=${encodeURIComponent(docType)}`);
  if (!res.ok) throw new Error(`Failed to load client checklist: ${res.status}`);
  return res.json();
}


